import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    transferenciasClientes: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state) {
        state.transferenciasClientes = [];
    },
    'SET_TRANSFERENCIAS_CLIENTES'(state, transferenciasClientes) {
        state.transferenciasClientes = transferenciasClientes;

        state.transferenciasClientes = [];
        for(let key in transferenciasClientes) {
            const transferencia = transferenciasClientes[key];
            let transferenciaCliente = {
                id: transferencia.id,
                fechaCreditoDebito: transferencia.fechaCreditoDebito,
                bancoCuenta: transferencia.bancoCuenta,
                numero: transferencia.numero,
                importe: transferencia.importe,
                selected: Boolean(false)
            }
            state.transferenciasClientes.push(transferenciaCliente);
        }             
    },
    'SET_TRANSFERENCIAS_SELECCIONADAS'(state, transferenciasSeleccionados) {
        if (transferenciasSeleccionados.length != 0) {
            for(let key in state.transferenciasClientes) {
                let transferencia = state.transferenciasClientes[key];
                if (transferenciasSeleccionados.some(tr => tr.id == transferencia.id )) {
                    transferencia.selected = true;
                }
            }
        }
    },
};

const actions = {
    getTransferenciasDisponibles: ({commit}, transferenciasSeleccionadas) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            let queryString = '';
            
            apiAxios.get('bancosmovimientos/transferenciasclientes' + queryString)
                .then(res => {
                    commit('SET_TRANSFERENCIAS_CLIENTES', res.data)

                    if (transferenciasSeleccionadas) {
                        if (transferenciasSeleccionadas != null) {
                            commit('SET_TRANSFERENCIAS_SELECCIONADAS', transferenciasSeleccionadas);
                        }
                    }

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,

    transferenciasClientesSeleccionadas(state) {
        let seleccionadas = [];
        if (state.transferenciasClientes.length != 0) {
            seleccionadas = state.transferenciasClientes
                .filter( tp => (/true/i).test(tp.selected) == Boolean(true));
        }
        return seleccionadas;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}